var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',[_c('h3',{staticClass:"md-title"},[_c('md-icon',[_vm._v("trip_origin")]),_vm._v(" "+_vm._s(_vm.$route.name)+" ")],1),_c('div',{staticClass:"md-layout"},[_c('md-card')],1)])}
var staticRenderFns = []

export { render, staticRenderFns }